import React from "react";

function PrivacyPolicy() {
	return (
		<div className="container px-4 mx-auto mt-5 mb-5">
			<div className="p-4 card" style={{ objectFit: "fill", borderRadius: "50px 0 50px 0" }}>
				<h1 className="mb-4 text-3xl font-bold text-center">Privacy Policy</h1>

				<p style={{ textAlign: "justify" }}>
					This product of Manakamana Savings and Credit Co-operative Limited. respects your privacy and are committed to
					protecting it through its compliance with its privacy policies. This page is used to inform visitors regarding
					our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our
					Service. If you choose to use our Service, then you agree to the collection and use of information in relation
					to this policy. The Personal Information that we collect is used for providing and improving the Service. We
					will not use or share our members' information with anyone except as described in this Privacy Policy. The
					terms used in this Privacy Policy have the same meaning as in our Terms and Conditions, which is accessible at
					Info Developers unless otherwise defined in this Privacy Policy.
				</p>

				<h2 className="mt-4 mb-3 text-2xl font-bold">Data Collection</h2>
				<p style={{ textAlign: "justify" }}>
					For a better experience, while using our Service, we may require you to provide us with certain personally
					identifiable information. By providing us your Information you hereby consent to the collection, storage,
					processing, disclosure and/or transfer of any or all of your personal & non-personal Information. The
					information includes:
				</p>
				<ul>
					<li>Photos or other files from the digital storage or that aren&apos;t owned by the app.</li>
					<li>
						Personal user information such as member&apos;s name, address, contact details, citizenship/National ID
						Card/PAN/driving license information, account details.
					</li>
					<li>
						App can access call details log, messages and other services such as camera access only if permission given
						by user.
					</li>
					<li>Our app collects real-time information about the location of your device, only if permission given by user.</li>
					<li>
						Mobile device ID information such as IMEI, Android ID, Unique mobile device identifier (e.g. IDFA or other
						device IDs on Apple devices like the iPhone and iPad)
					</li>
				</ul>

				<h2 className="mt-4 mb-3 text-2xl font-bold">How do we use the information?</h2>
				<p style={{ textAlign: "justify" }}>
					Any information that we collect from our members can be used in the following ways:
				</p>
				<ul>
					<li>Allow us to customize member&apos;s experience on our application/products.</li>
					<li>To make our application more user-friendly.</li>
					<li>
						To process transactions (Member&apos;s information, whether public or private, will not be sold, exchanged,
						transferred, or given to any other organization for any reason whatsoever, without respective member&apos;s
						consent, other than for the express purpose of delivering the purchased product or service requested)
					</li>
					<li>Improve the processing of financial transactions.</li>
				</ul>

				<h2 className="mt-4 mb-3 text-2xl font-bold">Data Security</h2>
				<p style={{ textAlign: "justify" }}>
					We value our member&apos;s trust in providing us your Personal Information; thus, we are thriving to use
					commercially acceptable means of protecting it. We implement a variety of security measures to maintain the
					safety of your personal information when our members perform a transaction or enter, submit, or access your
					personal information. All provided sensitive information is transmitted via Secure Socket Layer (SSL)
					technology.
				</p>

				<h2 className="mt-4 mb-3 text-2xl font-bold">Service Providers</h2>
				<p style={{ textAlign: "justify" }}>
					We may employ third-party tech companies and individuals due to the following reasons:
				</p>
				<ul>
					<li>To facilitate our Service.</li>
					<li>To provide the Service on our behalf.</li>
					<li>To perform Service-related services or</li>
					<li>To assist us in analyzing how our Service is used.</li>
				</ul>
				<p style={{ textAlign: "justify" }}>
					We want to inform users of this Service that these third parties have access to your Personal Information. The
					reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or
					use the information for any other purpose.
				</p>

				<h2 className="mt-4 mb-3 text-2xl font-bold">Links to Other Sites</h2>
				<p style={{ textAlign: "justify" }}>
					This Service may contain links to other sites. If you click on a third-party link, you will be directed to
					that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review
					the Privacy Policy of these websites. We have no control over and assume no responsibility for the content,
					privacy policies, or practices of any third-party sites or services.
				</p>

				<h2 className="mt-4 mb-3 text-2xl font-bold">Eligible Visitors</h2>
				<p style={{ textAlign: "justify" }}>
					These Services do not address anyone under the age of 16. We do not knowingly collect personally identifiable
					information from children under 16 years of age. In the case we discover that a child under 16 has provided us
					with personal information, we immediately delete this from our servers. The Electronic Channels is intended for
					the access of Nepali Citizens and residents of Nepal only. These Electronic Channels are compliant and its
					services are governed by the Nepalese Law. Over and above the present Terms and Service, Merchants must agree
					and qualify as per the conditions of the Merchant Agreement. The company reserves the right to terminate the
					access to any visitor at its discretion.
				</p>

				<h2 className="mt-4 mb-3 text-2xl font-bold">Changes to our Privacy Policy</h2>
				<p style={{ textAlign: "justify" }}>
					The Company reserves the right to change these conditions from time to time as it sees fit and continued use
					of the application will signify user acceptance of any adjustment to these policies. User is required to check
					privacy policy at every visit. No notification communication will be done subject to changes in the privacy
					policy.
				</p>

				<h2 className="mt-4 mb-3 text-2xl font-bold">Your Consent</h2>
				<p style={{ textAlign: "justify" }}>
					By using our application, you consent to our privacy policy. &copy;Manakamana Savings and Credit Co-operative
					Limited., Pathari Sanischare 01, Morang
				</p>
			</div>
		</div>
	);
}

export default PrivacyPolicy;
